'use client';

import type { FragmentType } from '@packages/gql/generated/shopping';
import type { SearchProductToProductsRecommendationsFragmentDoc } from '@packages/gql/generated/shopping/SearchProductToProductsRecommendationsFragmentDoc';
import { SearchProductToProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/SearchProductToProductsRecoSlider/SearchProductToProductsRecoSlider.client';
import { useIntl } from 'react-intl';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { unmask } from '@packages/gql/src/betterMasking';

/* GraphQL */ `
  fragment SearchProductToProductsRecommendations on Product {
    promotion
    orderNumber
  }
`;

export type SearchProductToProductsRecommendationsProps = {
  /**
   * The data from the product query needed for the `SearchProductToProductsRecoSlider` comnponent.
   */
  data: FragmentType<typeof SearchProductToProductsRecommendationsFragmentDoc>;
};

/**
 * This component is a wrapper for the `SearchProductToProductsRecoSlider` component.
 * It encapsulates the data from the product query needed for the `SearchProductToProductsRecoSlider` component and passes correct props.
 */
export const SearchProductToProductsRecommendations = ({
  data,
}: SearchProductToProductsRecommendationsProps) => {
  const { orderNumber, promotion } =
    unmask<typeof SearchProductToProductsRecommendationsFragmentDoc>(data);
  const { formatMessage } = useIntl();
  const {
    product: { hasTransparentSection },
  } = useConfig();

  return (
    <SearchProductToProductsRecoSlider
      productId={`${orderNumber}${promotion}`}
      elementIndex={0}
      fetchOnThreshold
      pageTemplate="detailview"
      title={formatMessage({
        id: 'rde.search-product-to-products.headline-fallback',
        defaultMessage: 'Ähnliche Artikel',
      })}
      key={`${orderNumber}0`}
      {...(hasTransparentSection && {
        backgroundColor: 'transparent',
      })}
    />
  );
};
